import { ConfigProvider, Spin } from "antd";
import { isEmpty } from "lodash";
import { useEffect } from "react";
import {
  Navigate,
  Route,
  Routes,
  useLocation,
  useNavigate
} from "react-router-dom";
import { useAppDispatch, useAppSelector } from "src/app/hooks";
import { fetchUseMe } from "src/appRedux/reducers/userReducer";
import "src/styles/custom.css";
import { getCookieValue } from "src/util/Commom";
import "./App.css";
import { selectUser } from "./appRedux/reducers/userReducer";
import { AdminLayout } from "./page/Admin/AdminLayout";
import Forbidden from "./routes/Forbidden";
import SignIn from "./routes/SingIn";
import HomeLayout from "./page/Public/Layout/Home";

const App = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const useInfo = useAppSelector(selectUser);
  const authuser = useInfo?.user || undefined;
  const accessToken = getCookieValue("accessTokenTVDTBDT") || null;
  const location = useLocation();

  useEffect(() => {
    if (accessToken && isEmpty(authuser)) {
      dispatch(fetchUseMe());
    }

    if (!authuser) {
      if (location.pathname === "/") {
        navigate("/trang-chu");
      }
    } else if (
      location.pathname === "/dang-nhap"
    ) {
      navigate("/home");
    } else {
      navigate(location.pathname);
    }
  }, [authuser, accessToken, dispatch, location.pathname]);

  if (isEmpty(authuser) && accessToken) {
    return (
      <div style={{ textAlign: "center", marginTop: "50px" }}>
        <Spin size="large" />
      </div>
    );
  }

  return (
    <ConfigProvider>
      <Routes>
        <Route path="/dang-nhap" element={<SignIn />} />
        <Route path="/Forbidden" element={<Forbidden />} />
        <Route path="/dang-nhap/Forbidden" element={<Forbidden />} />
        <Route path="/trang-chu/*" element={<HomeLayout />} />
        <Route
          path="/*"
          element={
            accessToken ? <AdminLayout /> : <Navigate to="/trang-chu/" replace />
          }
        />
      </Routes>
    </ConfigProvider>
  );
};

export default App;
